<template>
  <div v-if="!isUserEmailVerified" class="block-cover">
    <div class="popup-top-layer popup-mobile-dim">
      <div class="popup-background-layer popup">
        <div class="popup-container popup-container-mobile">
          <b-img :src="BigCrossIcon" alt=""></b-img>
          <div class="bottom-container">
            <div class="top-section-container">
              <div class="heading-desktop">
                <!--                      <b-img :src="BigCrossIcon" alt=""></b-img>-->
                <div class="heading-text">
                  <h3>Verify your email</h3>
                </div>
              </div>
              <div class="subtitle-text">
                <p class="mb-0">Check your email <b>{{ email }}</b></p>
                <p>for verification code</p>
              </div>
            </div>
            <div class="position-relative flex-grow-1">
              <div class="code-message">Enter here</div>
              <CodeInput ref="codeInputRef" :fields="6"
                         :loading="false"
                         autoFocus
                         class="verification-code-box"
                         type="text"
                         v-on:change="onChange"
                         v-on:complete="onComplete"
              />
              <p v-if="codeStatusMessage !== null"
                 :class="{
                        'text-danger': !codeSuccessStatus,
                        'text-success': codeSuccessStatus
                      }"
                 class="mt-3 mb-0">
                {{ codeStatusMessage }}
              </p>

              <div class="d-flex justify-content-center align-items-center">
                <b-button class="resend-button position-relative" variant="link" @click="resendCode">Resend
                  <b-spinner v-show="resendingCodeInProgress" class="spinner" label="Spinning" small
                             variant="success"></b-spinner>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-background-layer background"></div>
    </div>
  </div>
</template>
<script>
import BigCrossIcon from "@/module_b2b_users/assets/icons/big-cross.svg";
import CodeInput from "vue-verification-code-input";
import b2bService from "@/module_b2b_users/api/api";

export default {
  components: {
    CodeInput,
  },
  data() {
    return {
      BigCrossIcon: BigCrossIcon,
      codeStatusMessage: null,
      codeSuccessStatus: false,
      resendingCodeInProgress: false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state?.userInfo;
    },
    email() {
      return this.userInfo?.email || 'email';
    },
    isUserEmailVerified() {
      return !!this.userInfo?.isEmailVerified;
    }
  },
  methods: {
    onChange(code) {
      this.codeStatusMessage = null;
    },
    async onComplete(code) {
      code = code.toUpperCase();
      await this.validateCode(code);
    },
    async validateCode(code) {
      this.codeStatusMessage = null;
      this.codeStatusMessage = 'Validation...';
      this.codeSuccessStatus = true;
      // api call.
      await b2bService.verifyEmailVerificationCode({
        code
      }).then(isVerified => {
        if (isVerified) {
          this.codeStatusMessage = 'Your email validated successfully.';
          this.codeSuccessStatus = true;
          this.$store.dispatch('loadUserDetails');
          setTimeout(_ => this.$router.push(this.$store.state.defaultLandingPage), 3000);
        } else {
          this.codeStatusMessage = 'Enter correct code';
          this.codeSuccessStatus = false;
        }
      }).catch(err => {
        this.codeStatusMessage = 'Currently unable to verify';
        this.codeSuccessStatus = false;
      })
    },
    async resendCode() {
      this.resendingCodeInProgress = true;
      this.codeStatusMessage = null;
      this.codeSuccessStatus = false;
      await b2bService.resendEmailVerificationCode()
          .then(_ => {
            this.codeStatusMessage = 'Resent the verification code';
            this.codeSuccessStatus = true;
          })
          .catch(_ => {
            this.codeStatusMessage = 'Failed to send verification code';
            this.codeSuccessStatus = false;
          })
          .finally(_ => {
            this.resendingCodeInProgress = false;
          })
    }
  },
  mounted() {
    if (this.isUserEmailVerified) this.$router.push(this.$store.state.defaultLandingPage);
  }
}
</script>
<style lang="scss" scoped>
.block-cover {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0 5% 5% 5%;
  background-color: rgb(175 180 187 / 70%);
  pointer-events: all;
  align-items: center;
  justify-content: center;
  overflow: auto;
}

.code-message {
  font-size: 21px;
  padding: 8px;
}

::v-deep.verification-code-box {
  input {
    width: 30px !important;
    height: 32px !important;
    text-transform: uppercase;
  }
}

.popup-top-layer {
  position: relative;
  width: 570px;
  height: 342px;
  margin: auto;
  border-radius: 15px;
  overflow: hidden;

  .popup-background-layer {
    &.background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #ffffff;
    }

    &.popup {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }

  .popup-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;

    .left-container {
      height: 100%;

      img {
        max-height: 100%;
      }
    }

    .right-container {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 5px 16px 20px 16px;
      margin-top: 35px !important;

      .top-section-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        color: #000000;

        .heading-desktop {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin: 5px auto;

          img {
            max-width: 124px;
            max-height: 118px;
          }

          .heading-text {
            display: flex;
            flex-direction: column;

            h2 {
              padding-left: 0px;
              font-size: 25px;
              font-weight: 700;
              margin-bottom: 0 !important;
              line-height: 38px;
              letter-spacing: 0em;
              text-align: center;

            }
          }
        }

        .subtitle-text {
          p {
            font-size: 18px;
            font-weight: 400;
            line-height: 27px;
            letter-spacing: 0em;
            text-align: center;

          }
        }
      }
    }
  }
}

.popup-mobile-dim {
  margin-top: 5%;
  width: 500px;
  height: 460px;
  max-width: 100%;
  border-radius: 15px;
  overflow: hidden;

  .popup-container-mobile {
    flex-direction: column;

    img {
      max-width: 100%;
      max-height: 145px;
      margin: auto;
    }
  }

  .bottom-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    padding: 5px 21px 20px 16px;
    margin-top: 0px !important;

    .top-section-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      color: #000000;

      .heading-desktop {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 5px auto;

        img {
          max-width: 124px;
          max-height: 118px;
        }

        .heading-text {
          display: flex;
          flex-direction: column;

          h2 {
            padding-left: 0px;
            font-weight: 700;
            margin-bottom: 0 !important;
            font-size: 32px;
            line-height: 48px;
            letter-spacing: 0em;
            text-align: center;
          }
        }
      }

      .subtitle-text {
        p {
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          text-align: center;

        }
      }
    }
  }
}

.resend-button {
  margin-top: 1em;
  background-color: inherit;
  border-radius: 25px;
  width: 100px;
  height: 39px;
  max-width: 400px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #73bc44;
  text-decoration: none;
  border-width: 0;
  padding-right: 0;
  box-shadow: none;
}

.spinner {
  position: absolute;
  left: 100%;
  top: 25%;
}
</style>